import { Tag } from "antd";

import {
  PROJECT_WORK_TYPE_LABEL,
  type ProjectWorkType
} from "@/types/projectJobTypes";

/** antd preset tag colors — readable in both the light and dark tag palettes. */
const WORK_TYPE_COLOR: Record<ProjectWorkType, string> = {
  groundworks: "green",
  roadsAndSewers: "geekblue",
  both: "purple",
  unknown: "default"
};

interface ProjectWorkTypeTagProps {
  workType: ProjectWorkType;
}

/**
 * Tells at a glance whether a project is Groundworks, Roads & Sewers, or
 * both. Renders nothing for `unknown` (no job-types record) rather than an
 * "Unknown" pill — an absent tag reads as "not recorded", a pill reads as a
 * third work type.
 */
const ProjectWorkTypeTag = ({ workType }: ProjectWorkTypeTagProps) => {
  if (workType === "unknown") return null;

  return (
    <Tag color={WORK_TYPE_COLOR[workType]} className="m-0">
      {PROJECT_WORK_TYPE_LABEL[workType]}
    </Tag>
  );
};

export default ProjectWorkTypeTag;
